var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1071 310",
    width: 1071,
    height: 310,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MATERIAL BASE LOGO NUEVO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: #16d7db } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Artboards_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m132.6 201.7q-29.7 0-49.1-19.8-19.4-19.7-19.4-48.7 0-29.2 19.4-48.9 19.4-19.7 49.1-19.7 17.9 0 33.1 8.4 15.1 8.4 23.6 22.7l-22.4 13q-4.9-8.9-14-13.9-9-4.9-20.3-4.9-19.2 0-31 12-11.7 12.1-11.7 31.3 0 19 11.7 31 11.8 12.1 31 12.1 11.3 0 20.4-5 9.2-5 13.9-13.7l22.4 13q-8.5 14.3-23.5 22.7-15.1 8.4-33.2 8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m225.2 121.1q3.4-9 11.2-13.5 7.9-4.6 17.5-4.6v27.1q-11.1-1.3-19.9 4.6-8.8 5.8-8.8 19.4v45h-24.2v-94.2h24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m280.2 162q4.9 17.7 26.6 17.7 13.9 0 21-9.5l19.6 11.3q-13.9 20.2-41 20.2-23.4 0-37.5-14.1-14.1-14.2-14.1-35.6 0-21.3 13.9-35.5 14-14.2 35.8-14.2 20.7 0 34.2 14.3 13.4 14.3 13.4 35.4 0 4.7-0.9 10zm-0.4-18.9h48q-2-9.6-8.5-14.3-6.5-4.7-14.8-4.7-9.8 0-16.2 5-6.4 5-8.5 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m435 67.3h24.3v131.8h-24.3v-11.2q-10.8 13.8-30.5 13.8-19 0-32.5-14.4-13.5-14.4-13.5-35.3 0-20.9 13.5-35.3 13.5-14.4 32.5-14.4 19.7 0 30.5 13.7zm-44.7 103.9q7.4 7.4 18.7 7.4 11.3 0 18.6-7.4 7.4-7.5 7.4-19.2 0-11.6-7.4-19.1-7.3-7.4-18.6-7.4-11.3 0-18.7 7.4-7.5 7.5-7.5 19.1 0 11.7 7.5 19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m645.3 104.9h24.3v94.2h-24.3v-11.2q-10.9 13.8-30.7 13.8-18.8 0-32.3-14.4-13.5-14.4-13.5-35.3 0-20.9 13.5-35.3 13.5-14.4 32.3-14.4 19.8 0 30.7 13.7zm-44.8 66.2q7.3 7.4 18.6 7.4 11.3 0 18.7-7.4 7.5-7.4 7.5-19.1 0-11.7-7.5-19.1-7.4-7.5-18.7-7.5-11.3 0-18.6 7.5-7.4 7.4-7.4 19.1 0 11.7 7.4 19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m749 104.9h24.3v94.2h-24.3v-10.6q-8.8 13.2-28 13.2-15.5 0-25.6-10.4-10-10.3-10-28.6v-57.8h24.3v54.8q0 9.4 5 14.4 5.1 5 13.6 5 9.4 0 15.1-5.8 5.6-5.9 5.6-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m844.6 128.3h-21.2v39.1q0 4.9 2.4 7.2 2.5 2.2 7.2 2.5 4.7 0.3 11.6-0.1v22.1q-25 2.8-35.3-4.8-10.2-7.5-10.2-26.9v-39.1h-16.4v-23.4h16.4v-19l24.3-7.3v26.3h21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m934.5 187.3q-14.5 14.4-35.4 14.4-20.9 0-35.3-14.4-14.4-14.4-14.4-35.3 0-20.9 14.4-35.3 14.4-14.4 35.3-14.4 20.9 0 35.4 14.4 14.5 14.4 14.5 35.3 0 20.9-14.5 35.3zm-53.6-16.7q7.2 7.4 18.2 7.4 10.9 0 18.2-7.4 7.4-7.3 7.4-18.6 0-11.3-7.4-18.7-7.3-7.3-18.2-7.3-11 0-18.2 7.3-7.3 7.4-7.3 18.7 0 11.3 7.3 18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m981.7 131.7q0 3.7 5 6.1 5 2.3 12.1 4.1 7.2 1.8 14.4 4.5 7.1 2.8 12.1 9.2 5 6.4 5 16 0 14.5-10.8 22.3-10.9 7.8-27.1 7.8-29 0-39.5-22.4l21.1-11.9q4.1 12.3 18.4 12.3 13 0 13-8.1 0-3.8-5-6.2-4.9-2.3-12.1-4.2-7.2-1.9-14.3-4.7-7.2-2.8-12.1-8.9-5-6.2-5-15.4 0-13.9 10.2-21.9 10.3-8 25.5-8 11.5 0 20.9 5.2 9.4 5.1 14.9 14.7l-20.7 11.3q-4.5-9.6-15.1-9.6-4.7 0-7.8 2.1-3.1 2.1-3.1 5.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m590.4 23.2c-6.3-2.8-13.7-0.2-16.7 6.1l-70.9 148.7c0 0-7.8 16.3 3.5 21.4 0 0 11.3 5.1 18.8-11.3l71.4-147.9c3-6.4 0.3-14-6.1-17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m512.5 200.1v-85.7q0.1-10.7-11.5-10.7h-23.1v12.1h2.4q8.6 0 8.6 7.7v76.6zm-15.1-133.4q-15.8 0-15.8 11.7 0 11.9 15.8 11.9 15.7 0 15.7-11.9 0-11.7-15.7-11.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m739.6 237.4q3.9 0 6.7 1.5 2.7 1.4 3.6 3.8v-16.9h7.6v44.4h-7.6v-4.7q-0.9 2.4-3.6 3.9-2.8 1.5-6.7 1.5-6.8 0-11.5-4.8-4.6-4.9-4.6-12 0-7.1 4.6-11.9 4.7-4.8 11.5-4.8zm1 26.5q4.2 0 7-2.8 2.9-2.7 2.8-7 0.1-4.2-2.8-7-2.8-2.8-7-2.8-4 0-6.8 2.8-2.7 2.8-2.7 7 0 4.3 2.7 7 2.8 2.8 6.8 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m758.9 254.4v-0.3q0-7.5 4.8-12.2 4.7-4.7 12.1-4.7 7 0 11.4 4.7 4.4 4.6 4.4 11.5 0 1-0.1 2.6h-25q0.2 3.9 2.8 6.2 2.7 2.3 6.9 2.3 5 0 8.7-3.7l4.6 4.4q-5.5 5.8-13.5 5.8-7.6 0-12.3-4.6-4.8-4.5-4.8-12zm7.8-3.7h17.2q0-2.8-2.5-4.9-2.4-2.1-5.6-2.1-3.6 0-6.2 2-2.6 2.1-2.9 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m858.2 232h-44.5v-6.4h44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m858.2 244.7h-44.5v-6.4h44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m858.2 257.4h-44.5v-6.3h44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m858.2 270.1h-44.5v-6.3h44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m880.5 225.6h17.7c7 0 12.7 4.8 12.7 11.4 0 4.3-2.1 7.6-5.7 8.9 5.8 1 8.9 5.5 8.9 11.1 0 7.5-5.7 13.1-13.5 13.1h-20.1zm16.1 17.8c2.8 0 4.7-2 4.7-4.8 0-2.6-1.9-4.6-4.7-4.6h-6.5v9.4zm2.1 18.2c3.3 0 5.7-2.3 5.7-5.4 0-3-2.4-5.2-5.8-5.2h-8.4v10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m925.6 225.6h9.8v44.5h-9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m971.1 224.9c7.2 0 13.6 3.2 18 8.3l-6.7 5.7c-2.8-3.1-6.9-5-11.3-5-8 0-14.1 6-14.1 14 0 8 6.1 14 14.1 14 4.4 0 8.5-1.9 11.3-5.1l6.7 5.7c-4.4 5.1-10.8 8.3-18 8.3-13.3 0-24-9.6-24-22.9 0-13.3 10.7-23 24-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m999.5 225.6h30.4v9h-20.6v8.3h19.2v8.8h-19.2v9.5h21v8.9h-30.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.04fb7cc433deaada83fc6f4601759d0f.svg";
export { ForwardRef as ReactComponent };